'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of supplement ed
 */ const SupplementEd = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_21768)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M79.7578 46.2837C79.6227 31.358 67.4198 19.1927 52.4942 19.1001C37.2631 19.0075 24.8876 31.328 24.8876 46.5365C24.8876 47.3924 24.9302 48.2307 25.0103 49.0641C25.0553 49.5496 24.9702 50.0401 24.765 50.4806L20.5731 60.7839C20.3979 61.2119 20.4255 61.6999 20.6732 62.0903C20.9185 62.4807 21.3439 62.721 21.8094 62.736L25.3106 63.2941C25.9788 63.4017 26.4693 63.9498 26.5519 64.6155L27.8107 74.8187C28.0159 76.4879 29.48 77.7117 31.1567 77.6191L35.4387 77.3864C37.7912 77.2587 39.7708 79.1332 39.7708 81.4907V84.7792C39.7708 84.9318 39.8934 85.0544 40.0461 85.0544H69.5471C69.7248 85.0544 69.8549 84.8868 69.8124 84.7141C67.6226 75.7046 68.9915 70.0987 73.3861 64.1224C77.4128 59.3024 79.8204 53.0733 79.7578 46.2862V46.2837Z",
                    fill: theme.ds5.asset[assetColor]["500"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip1_3427_21768)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M52.8879 28.2168C45.485 28.2168 39.4844 34.2174 39.4844 41.6225C39.4844 49.0276 45.485 55.026 52.8879 55.026C60.2908 55.026 66.2914 49.0254 66.2914 41.6225C66.2914 34.2196 60.2908 28.2168 52.8879 28.2168Z",
                    fill: theme.ds5.asset[assetColor]["100"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip2_3427_21768)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M43.3904 37.0703V39.8828V41.0078H44.5015H50.057H51.1682V39.8828V37.0703C51.1682 34.8941 49.4286 33.1328 47.2793 33.1328C45.13 33.1328 43.3904 34.8941 43.3904 37.0703ZM52.2793 43.2578C52.2793 46.3656 54.7654 48.8828 57.8348 48.8828C58.8383 48.8828 59.7793 48.6121 60.5918 48.141C61.0189 47.8914 61.0466 47.3078 60.6994 46.9527L54.1855 40.3574C53.8383 40.0059 53.2584 40.0305 53.0119 40.4664C52.5466 41.2891 52.2793 42.2418 52.2793 43.2578ZM54.9702 39.5629L61.4841 46.1582C61.8314 46.5098 62.4112 46.4852 62.6577 46.0492C63.123 45.2266 63.3904 44.2738 63.3904 43.2578C63.3904 40.15 60.9043 37.6328 57.8348 37.6328C56.8314 37.6328 55.8904 37.9035 55.0779 38.3746C54.6508 38.6242 54.623 39.2078 54.9702 39.5629Z",
                        fill: theme.ds5.asset[assetColor]["400"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M44.5017 41.0078H43.3906V42.1328V44.9453C43.3906 47.1215 45.1302 48.8828 47.2795 48.8828C49.4288 48.8828 51.1684 47.1215 51.1684 44.9453V42.1328V41.0078H50.0573H44.5017Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip0_3427_21768",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "59.2973",
                            height: "65.9518",
                            fill: "white",
                            transform: "translate(20.4609 19.0996)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip1_3427_21768",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "26.807",
                            height: "26.807",
                            fill: "white",
                            transform: "translate(39.4844 28.2168)"
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                        id: "clip2_3427_21768",
                        children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                            width: "20",
                            height: "18",
                            fill: "white",
                            transform: "translate(43.3906 32.0078)"
                        })
                    })
                ]
            })
        ]
    });
};

exports.SupplementEd = SupplementEd;
//# sourceMappingURL=SupplementEd.cjs.map
